// import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
// import Footer from '@/themes/default/elements/footer/Footer';
// import Header from '@/themes/default/elements/Header/Header';
// import { ReactNode } from 'react';


// export default async function MainLayout({
//     children,
// }: Readonly<{
//     children: ReactNode;
// }>) {
//     return (
//         <>
//             <OrganizationSchema /> {/* ✅ Invisible - only for search engines to improve seo - because of the <script type="application/ld+json"> tag in the file */}
//             <Header />
//             <main className="flex flex-col min-h-[calc(100vh-72px)]">
//                 <div className="min-h-full">{children}</div>
//                 <Footer />
//             </main>
//         </>
//     );
// }


import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
import Footer from '@/themes/default/elements/footer/Footer';
import Header from '@/themes/default/elements/Header/Header';
import MainContentWrapper from '@/themes/default/elements/Header/MainContentWrapper';
import { ReactNode } from 'react';
// برند شمشک (NEXT_PUBLIC_THEME=eram) تا امروز هیچ دکمه‌ی پشتیبانی شناوری
// نداشت. به‌جای ساختن یه نسخه‌ی تکراری دیگه، همون کامپوننت برند-آگاه تولیکا
// رو که وندا/شمشک رو هم می‌شناسه استفاده می‌کنیم (2026-10-19).
import SupportWidget from '@/themes/tolica/components/AdminSupportButton';
import { getSettings } from '@/core/lib/api/main/setting';


export default async function MainLayout({
    children,
}: Readonly<{
    children: ReactNode;
}>) {
    const settingsRes = await getSettings().catch(() => null);
    const isSupportActive = settingsRes?.support_widget_active !== 'deactive';
    // این تم (eram) رو خودِ برند «اروم هوم» هم استفاده می‌کنه، نه فقط شمشک -
    // عمداً فقط برای شمشک فعالش می‌کنیم تا یهو یه ویجت جدید (با رنگ/لینک
    // نامربوط) برای اروم هوم ظاهر نشه.
    const showSupportWidget = process.env.NEXT_PUBLIC_SITE_NAME === 'shemshak';

    return (
        <>
            <OrganizationSchema />
            <Header />
            <main className="flex flex-col min-h-[calc(100vh-72px)]">
                <MainContentWrapper>{children}</MainContentWrapper>
                <Footer />
            </main>
            {showSupportWidget && <SupportWidget active={isSupportActive} />}
        </>
    );
}